export const EMPTY_OBJECT = Object.freeze({}) as Record<any, any>;
